import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  StockRuleDeleteResult,
  StockRuleQuery,
  StockRuleRow,
  StockRuleSaveRequest,
  StockRuleSaveResult
} from '../types/stockRule';

const BASE = '/wl/stock-rule';

/**
 * 库存预警/补货规则（`cfg_stock_rule`）：
 * 匹配优先级 指定物资 → 指定品类 → 默认规则，是补货建议与库存预警的阈值来源。
 */
export function createStockRuleApi(http: HttpClient) {
  return {
    list(query: StockRuleQuery = {}): Promise<StockRuleRow[]> {
      return http.request<StockRuleRow[]>({ path: BASE, query: toQuery(query) });
    },

    /** 新增（id 为空）或更新。 */
    save(body: StockRuleSaveRequest): Promise<StockRuleSaveResult> {
      return http.request<StockRuleSaveResult>({ path: BASE, method: 'POST', body });
    },

    remove(id: Id): Promise<StockRuleDeleteResult> {
      return http.request<StockRuleDeleteResult>({ path: `${BASE}/${id}`, method: 'DELETE' });
    }
  };
}

export type StockRuleApi = ReturnType<typeof createStockRuleApi>;
